import { SiteUrlsContext } from '@tableau/data-catalog-shared';
import { ButtonWidget } from '@tableau/widgets';
import { ButtonType } from '@tableau/widgets/lib/src/widgets/Button/ButtonWidget';
import * as React from 'react';
import { Messages } from '../../../gen-src/Localize';
import { SvgExpand } from '../../../gen-src/icons/Expand';
import { TableauExpressionFormatter } from '../tableauExpression/components/TableauExpressionFormatter';
import { CalculationDialog } from './CalculationDialog';
import { SheetFieldWithCalculation } from './SheetField';
import {
  ExpandIconWrapper,
  FieldCardDetailText,
  FieldCardDetailTitle,
  FieldCardDetailTitleWrapper
} from './VizClientFieldCardStyles';

export type CalculationDetailsProps = {
  readonly field: SheetFieldWithCalculation;
  readonly workbookVizportalUrlId?: string;
};

export function CalculationDetails(props: CalculationDetailsProps): JSX.Element {
  const [isOpen, toggleDialog] = React.useState(false);
  const openDialog = () => toggleDialog(true);
  const onClose = () => toggleDialog(false);

  const formula = props.field.formula;
  return (
    <>
      <FieldCardDetailTitleWrapper>
        <FieldCardDetailTitle>{Messages.DataDetailsCalculation()}</FieldCardDetailTitle>
        <ExpandIconWrapper>
          <ButtonWidget
            buttonType={ButtonType.Icon}
            handleClick={openDialog}
            title={Messages.DataDetailsCalculationDialogExpandAltText()}
            testId={'data-details-calculation-expand'}
            getContent={() => { return <SvgExpand />; }}
          />
        </ExpandIconWrapper>
      </FieldCardDetailTitleWrapper>
      <FieldCardDetailText>
        <SiteUrlsContext.Consumer>
          {urls =>
            <>
              <TableauExpressionFormatter
                // The code was like this before the lint rule was enabled
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                expression={formula!}
                fields={props.field.fields}
                parameters={props.field.parameters}
                makeFieldUrl={(fieldId) =>
                  props.workbookVizportalUrlId
                    ? urls.workbookLineageFieldUrl(props.workbookVizportalUrlId, fieldId)
                    : ''
                }
                openLinksInNewTab={true}
              />
              <CalculationDialog
                isOpen={isOpen}
                onClose={onClose}
                field={props.field}
                workbookVizportalUrlId={props.workbookVizportalUrlId}
                siteUrls={urls}
              />
            </>
          }
        </SiteUrlsContext.Consumer>
      </FieldCardDetailText>
    </>
  );
}
